import styled from 'styled-components';
import { Typography } from '../../../assets/styles/StyleTypes';

export const Text = styled.div`
  display: flex;
  text-align: flex-start;
  ${Typography.BODY_XS};
  margin-bottom: 10px;
`;

export const Text2 = styled.div`
  display: flex;
  justify-content: space-around;
  text-align: center;
  ${Typography.BODY_XS}
`;

export const Columns = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  
  max-height: 300px;
  overflow-y: auto;

  & > div {
    flex-basis: calc(50% - 10px); /* Cada coluna ocupa metade do espaço, menos 10px de margem */
    margin-bottom: 20px; /* Espaço entre as linhas */
  }
`;